import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { CacheService, Entity, IEntamapBO } from '@mapfre-tech/amap3';
import moment from 'moment';
import { Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../../../environments/environment";

@Injectable({
   providedIn: "root"
})
export class EntityService {

   className = 'EntityService'

   memoryCache: any = {
      "entitiesBySO": {
         "data": null,
         "lastReqDate": null
      },
      "entitiesByCountryId": {
         "data": null,
         "lastReqDate": null
      }
   }

   sections = [
      'administration',
      'works/dashboard',
      'recommendations/dashboard',
      'following',
      'dashboard/budget'
   ]

   constructor(private http: HttpClient, private router: Router, private cacheService: CacheService) { }

   getAllEntities(showAll = false, cache = true): Observable<IEntamapBO[]> {
      const params: any = {};
      params.showAll = showAll;
      const isSection = _.some(this.sections, section => _.includes(this.router.url, section));
      const cacheKey = "allEntities"+"_"+showAll.toString()+"_"+isSection.toString()

      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey) as object as Observable<IEntamapBO[]>;
      } else {
         const observable = this.http.get<IEntamapBO[]>(environment.base_URL + "/entities", { params }).pipe(map((res) => {
            if(isSection){
               this.cacheService.updateCacheData(res, cacheKey)
               return res;
            }else{
               const filtrado =  _.filter(res, it => it.mrkActive);
               this.cacheService.updateCacheData(filtrado, cacheKey)
               return filtrado;
            }
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable as object as Observable<IEntamapBO[]>;
      }
   }

   getEntitiesByBusinessUnit(unitBusinessID: number, showAll = false): Observable<IEntamapBO[]> {
      const params: any = {};
      params.showAll = showAll;
      params.unitBusiness = unitBusinessID;
      return this.http.get<IEntamapBO[]>(environment.base_URL + '/entities', { params });
   }

   getEntitiesBySO(id: number, cache = true): Observable<IEntamapBO[]> {
      const isSection = _.some(this.sections, section => _.includes(this.router.url, section));
      const cacheKey = "entitiesBySO"+"_"+isSection.toString()

      if (cache && this.cacheService.canUseCache(cacheKey, [id.toString()])) {
         return this.cacheService.getCacheData(cacheKey, [id.toString()]) as object as Observable<IEntamapBO[]>;
      } else {
         const observable = this.http.get<IEntamapBO[]>(environment.base_URL + `/entities/organizational/${id}`).pipe(map((res) => {
            if(isSection){
               this.cacheService.updateCacheData(res, cacheKey, [id.toString()])
               return res;
            }else{
               const filtrado =  _.filter(res, it => it.mrkActive);
               this.cacheService.updateCacheData(filtrado, cacheKey, [id.toString()])
               return filtrado;
            }
         }))
         this.cacheService.updateCacheReq(cacheKey, [id.toString()] );
         return observable as object as Observable<IEntamapBO[]>;
      }
   }

   getEntitiesByCountriesId(countriesIds: number[], cache = true): Observable<IEntamapBO[]> {
      const params = {
         countriesIdsList: countriesIds.join(',')
      }
      const isSection = _.some(this.sections, section => _.includes(this.router.url, section));
      const cacheKey = "entitiesByCountryId"+"_"+isSection.toString()

      if (cache && this.cacheService.canUseCache(cacheKey, [countriesIds.toString()])) {
         return this.cacheService.getCacheData(cacheKey, [countriesIds.toString()]) as object as Observable<IEntamapBO[]>;
      } else {
         const observable = this.http.get<IEntamapBO[]>(environment.base_URL + "/entities", { params }).pipe(map((res) => {
            if(isSection){
               this.cacheService.updateCacheData(res, cacheKey, [countriesIds.toString()])
               return res;
            }else{
               const filtrado =  _.filter(res, it => it.mrkActive);
               this.cacheService.updateCacheData(filtrado, cacheKey, [countriesIds.toString()])
               return filtrado;
            }
         }))
         this.cacheService.updateCacheReq(cacheKey, [countriesIds.toString()] );
         return observable as object as Observable<IEntamapBO[]>;
      }
   }   

   removeById(array: IEntamapBO[]) {
      array.forEach((element: IEntamapBO) => {
         delete element.idEntityPk;
      });
      return array;
   }

   newEntity(entity: IEntamapBO) {
      return this.http.post(environment.base_URL + "/entities", entity);
   }

   updateEntity(entity: IEntamapBO, id: number) {
      return this.http.put(environment.base_URL + `/entities/${id}`, entity);
   }

   deleteEntity(id: number) {
      return this.http.delete(environment.base_URL + `/entities/${id}`);
   }

   canUseCache(key: any) {
      const oldDate = _.get(this.memoryCache, `${key}.lastReqDate`);
      let canUse = false;
      if (moment().diff(oldDate, 'minutes') <= 1) {
         canUse = true;
      }
      return canUse;
   }

   updateCacheData(data: any, key: any) {
      _.set(this.memoryCache, `${key}.data`, data);

      _.get(this.memoryCache, `${key}._subject`).next(data);
   }

   updateCacheReq(key: any) {
      const _subject = new Subject<any>();
      const observer = _subject.asObservable();
      _.set(this.memoryCache, key, { observer, _subject, lastReqDate: moment() });
   }


}
